import React from 'react'
import _ from 'underscore'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import Modal from '../modal'
import JobReadiness from '../enquiry/lesson_plans/job_readiness'
import TutorSearcherPosition from './position'
import store from '../../state/store'
import Timeago from '../timeago'

class TutorSearcher extends React.Component {

  onStartSearch = () => {
    store.emit('tutoring_job:tutor_search:start')
  }

  onStopSearch = () => {
    store.emit('tutoring_job:tutor_search:stop')
  }

  onClose = () => {
    store.emit('ui:tutor_searcher:close')
  }

  render() {
    const title = (
      <span>
        Start New Search
        {this.props.tutoring_job.tutor_search.last_search_at ?
          <Badge variant="success" className="ml-2 uppercase">Last Search: <Timeago date={this.props.tutoring_job.tutor_search.last_search_at}/></Badge>
          : null
        }
      </span>
    )

    return (
      <Modal title={title} size="modal-lg" onClose={this.onClose}>
        <div className="grid gap-4 p-6">
          {this.props.lesson_plan &&
            <JobReadiness lesson_plan={this.props.lesson_plan} />
          }
          <div className="grid gap-1">
            {_.map(this.props.tutoring_job.tutoring_job_positions, (position) => {
              const selected = this.props.ui.tutor_searcher.position_ids.includes(position.id)

              return (
                <TutorSearcherPosition
                  key={position.id}
                  tutoring_job_position={position}
                  selected={selected}
                />
              )
            })}
          </div>
          <div className="flex justify-end gap-2">
            <Button variant="outline" size="sm" onClick={this.onClose}>Close</Button>
            {(this.props.tutoring_job.tutor_search.searching === true) ?
              <Button variant="destructive" size="sm" onClick={this.onStopSearch}>Stop Tutor Search</Button>
              : null
            }
            {(this.props.tutoring_job.tutor_search.searching === false) ?
              <Button size="sm" onClick={this.onStartSearch}>Start Search</Button>
              : null
            }
          </div>
        </div>
      </Modal>
    )
  }
}

export default TutorSearcher
